var map = {
	"./core/Footer.vue": "7a74",
	"./core/NavBar.vue": "a7a0",
	"./core/Sidedrawer.vue": "d9a1",
	"./dialogs/CriptoModalComponent.vue": "9352",
	"./dialogs/DialogClipboardComponent.vue": "100b",
	"./dialogs/DialogMessages.vue": "ca54",
	"./dialogs/DialogMessagesComponent.vue": "da92",
	"./dialogs/DialogQuestion.vue": "7dc0",
	"./dialogs/DialogTipoBot.vue": "2caa",
	"./dialogs/SelectModalidadComponent.vue": "ca76",
	"./error/Error.vue": "994e",
	"./error/NotFound.vue": "7b00",
	"./materialfy/ApexDonut.vue": "91db",
	"./materialfy/ApexLineGraph.vue": "0aec",
	"./materialfy/ApexMultipleRadialBars.vue": "e429",
	"./materialfy/ApexPolarMap.vue": "f247",
	"./materialfy/ApexYAxis.vue": "e61b",
	"./materialfy/ApiSave.vue": "2d26",
	"./materialfy/ApiTable.vue": "8e7d",
	"./materialfy/BasicCard.vue": "a129",
	"./materialfy/BasicTextCard.vue": "e187",
	"./materialfy/BotAutoSave.vue": "0334",
	"./materialfy/BotStandardSave.vue": "d343",
	"./materialfy/BotsOrders.vue": "f27c",
	"./materialfy/BotsTable.vue": "1121",
	"./materialfy/Calendar.vue": "d64d",
	"./materialfy/ChartBots.vue": "5cf7",
	"./materialfy/ColorCard.vue": "dd72",
	"./materialfy/DataCard.vue": "3537",
	"./materialfy/DataChart.vue": "2a84",
	"./materialfy/DataChartHome.vue": "fdca",
	"./materialfy/DataHome.vue": "e34b",
	"./materialfy/DataTable.vue": "d615",
	"./materialfy/DataTables.vue": "febe",
	"./materialfy/HeaderCard.vue": "cac4",
	"./materialfy/HeaderDataTable.vue": "f48f",
	"./materialfy/Notifications.vue": "94db",
	"./materialfy/Settings.vue": "4774",
	"./materialfy/Toasts.vue": "a425",
	"./materialfy/userSnippet.vue": "ade1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ffe0";